import { useCallback, useEffect, useRef, useState } from "react";

import { SEARCH_QUERY_MIN_CHARS } from "@/components/layout/Navbar/ApplicationSearch/application-search.consts";
import { SearchResultItem } from "@/components/layout/Navbar/ApplicationSearch/application-search.types";
import { useOutsideClick } from "@/hooks/useOutsideClick";

export const useShowResults = (query: string, recentSearches: SearchResultItem[]) => {
    const [showResults, setShowResults] = useState(false);
    const ref = useRef(null);

    const handleOpen = useCallback(() => {
        setShowResults(true);
    }, []);

    const handleClose = useCallback(() => {
        setShowResults(false);
    }, []);

    useOutsideClick(ref, handleClose);

    // Close search results if search query is too short
    useEffect(() => {
        if (query.length >= SEARCH_QUERY_MIN_CHARS) {
            handleOpen();
        } else if (recentSearches.length === 0) {
            handleClose();
        }
    }, [query, recentSearches, handleOpen, handleClose]);

    return { ref, showResults, handleOpen, handleClose };
};
